export default String.raw`
<g id="Stopka rozwinieta z ikonami na bialym tle">
    <g id="Kolorowa stopka">
        <rect width="360" height="698" class="footerColorBackground"/>
        <g id="Frame 30">
            <g id="Sekcja">
                <g id="naglowek">
                    <text id="O nas" class="footerColorFont" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="16" font-weight="600" letter-spacing="0px">
                        <tspan x="16" y="47.8182">TRANSLATION_Prv_AboutUs</tspan>
                    </text>
                    <g id="Arrows/chevron down" transform="translate(320.000000, 31.000000)">
                        <use class="footerColorFont" xlink:href="#chevron-down" width="24" height="24"></use>
                    </g>
                </g>
                <g id="divider">
                    <rect width="328" height="1" transform="translate(16 72)" class="footerColorFont"/>
                </g>
            </g>
            <g id="Sekcja_2">
                <g id="naglowek_2">
                    <text id="O firmie_2" class="footerColorFont" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="16" font-weight="600" letter-spacing="0px">
                        <tspan x="16" y="104.818">TRANSLATION_Prv_Orders</tspan>
                    </text>
                    <g id="Arrows/chevron down_2" transform="translate(320.000000, 88.000000)">
                        <use class="footerColorFont" xlink:href="#chevron-down" width="24" height="24"></use>
                    </g>
                </g>
                <g id="divider_2">
                    <rect width="328" height="1" transform="translate(16 129)" class="footerColorFont"/>
                </g>
            </g>
            <g id="Sekcja_3">
                <g id="naglowek_3">
                    <text id="O firmie_3" class="footerColorFont" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="16" font-weight="600" letter-spacing="0px">
                        <tspan x="16" y="161.818">TRANSLATION_Prv_YourAccount</tspan>
                    </text>
                    <g id="Arrows/chevron down_3" transform="translate(320.000000, 145.000000)">
                        <use class="footerColorFont" xlink:href="#chevron-down" width="24" height="24"></use>
                    </g>
                </g>
                <g id="divider_3">
                    <rect width="328" height="1" transform="translate(16 186)" class="footerColorFont"/>
                </g>
            </g>
            <g id="Sekcja_4">
                <g id="naglowek_4">
                    <text id="O firmie_4" class="footerColorFont" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="16" font-weight="600" letter-spacing="0px">
                        <tspan x="16" y="218.818">TRANSLATION_Prv_ImportantInfo</tspan>
                    </text>
                    <g id="Arrows/chevron down_4" transform="translate(320.000000, 202.000000)">
                        <use class="footerColorFont" xlink:href="#chevron-down" width="24" height="24"></use>
                    </g>
                </g>
                <g id="divider_4">
                    <rect width="328" height="1" transform="translate(16 243)" class="footerColorFont"/>
                </g>
            </g>
        </g>
        <g id="Frame 16">
            <g id="Sekcja/Kontakt">
                <g id="Stopka/Naglowek kolumny">
                    <text id="Naglowek" class="footerColorFont" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="16" font-weight="600" letter-spacing="0px">
                        <tspan x="16" y="283.818">TRANSLATION_Prv_Contact</tspan>
                    </text>
                </g>
                <g id="zawartosc">
                    <g id="Frame 7">
                        <g id="Interface/Mail" transform="translate(16.000000, 304.000000)">
                            <use class="footerColorLinks" xlink:href="#envelope" width="24" height="24"></use>
                        </g>
                        <g id="Stopka/Element kolumny">
                            <text id="Label" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                                <tspan x="48" y="320.364">e-sklep-test@comarch.pl</tspan>
                            </text>
                        </g>
                    </g>
                    <g id="Frame 8">
                        <g id="Interface/Headphones" transform="translate(16.000000, 344.000000)">
                            <use class="footerColorLinks" xlink:href="#headset" width="24" height="24"></use>
                        </g>
                        <g id="Frame 15">
                            <g id="Stopka/Element kolumny_2">
                                <text id="Label_2" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                                    <tspan x="48" y="356.364">12 681 43 00</tspan>
                                </text>
                            </g>
                            <g id="Stopka/Element kolumny_3">
                                <text id="Label_3" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" letter-spacing="0px">
                                    <tspan x="48" y="376.364">Pn-Pt. 8:00-16:00</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <g id="Social">
                <g transform="translate(16.000000, 404.000000)">
                    <image id="Instagram-icon" x="0" y="0" href="./img/instagram.png" height="24" width="24" />
                    <image id="Fb-icon" x="40" y="0" href="./img/fb.png" height="24" width="24" />
                    <image id="Twitter-icon" x="80" y="0" href="./img/twitter.png" height="24" width="24" />
                    <image id="Youtube-icon" x="120" y="0" href="./img/youtube.png" height="24" width="24" />
                </g>
            </g>
            <g id="divider_5">
                <rect width="328" height="1" transform="translate(16 452)" class="footerColorFont"/>
            </g>
        </g>
        <g id="Platnosc i dostawa">
            <text id="Dostawa i platnosc" fill="#F1DDDE" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="16" font-weight="600" letter-spacing="0px">
                <tspan x="16" y="492.091">TRANSLATION_Prv_Footer_DeliveryAndPayment</tspan>
            </text>
            <g id="Frame 6">
                <g id="icon delivery ">
                    <rect x="16" y="513" width="56" height="32" rx="4" class="footerBannerBackground"/>
                    <image id="Delivery/InPost" x="21" y="515" href="./img/deliveryAndPayment/delivery1.png" height="27" width="46" />
                </g>
            </g>
        </g>
        <g id="Frame 31">
            <rect x="80" y="513" width="56" height="32" rx="4" class="footerBannerBackground"/>
            <image id="Delivery/dpd" x="83" y="518" href="./img/deliveryAndPayment/delivery2.png" height="21" width="50" />
        </g>
        <g id="Frame 32">
            <rect x="144" y="513" width="56" height="32" rx="4" class="footerBannerBackground"/>
            <image id="Delivery/Poczta Polska" x="144" y="517" href="./img/deliveryAndPayment/delivery3.png" height="24" width="56" />
        </g>
        <g id="Frame 33">
            <rect x="208" y="513" width="68" height="32" rx="4" class="footerBannerBackground"/>
            <image id="Delivery/DHL" x="208" y="521" href="./img/deliveryAndPayment/delivery4.png" height="15" width="68" />
        </g>
        <g id="Frame 34">
            <rect x="284" y="513" width="56" height="32" rx="4" class="footerBannerBackground"/>
            <image id="Payment/PayU/colour" x="287" y="516" href="./img/deliveryAndPayment/payment1.png" height="25" width="50" />
        </g>
        <g id="Frame 35">
            <rect x="16" y="561" width="80" height="32" rx="4" class="footerBannerBackground"/>
            <image id="Payment/eservice/colour" x="16" y="569" href="./img/deliveryAndPayment/payment2.png" height="15" width="80" />
        </g>
        <g id="Frame 36">
            <rect x="104" y="561" width="56" height="32" rx="4" class="footerBannerBackground"/>
            <image id="Payment/tpay/colour" x="107" y="567" href="./img/deliveryAndPayment/payment3.png" height="20" width="50" />
        </g>
        <g id="Frame 37">
            <rect x="168" y="561" width="68" height="32" rx="4" class="footerBannerBackground"/>
            <image id="Payment/Przelewy24/colour" x="169" y="566" href="./img/deliveryAndPayment/payment4.png" height="22" width="65" />
        </g>
    </g>
    <g id="divider_6">
        <rect width="328" height="1" transform="translate(16 609)" class="footerColorFont"/>
    </g>
</g>
<g id="Comarch SA 2024. All rights reserved Powered by Comarch e-Sklep">
    <text class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px">
        <tspan x="16" y="645.636">© Comarch SA PREVIEW_YEAR. All rights reserved Powered by </tspan>
    </text>
    <text class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px">
        <tspan x="16" y="661.636">Comarch e-Sklep®</tspan>
    </text>
</g>
`;